<form [formGroup]="holderInfoFormGroup">
  <div class="p-form-layout01__item p-card-holder__wapper">
    <h3
      class="p-form-layout01__item-title p-form-layout01__item-title--l"
      [innerHTML]="'heading.cardholderImformation' | staticMsg"
    ></h3>
    <div class="p-input-block01">
      <div class="p-input-block01__item">
        <div class="p-input-block01__row p-input-block01__row--has-title">
          <div class="p-input-block01__row-head">
            <span class="p-input-block01__row-title" [innerHTML]="'label.eMailAddress' | staticMsg"></span>
            <span class="c-label-required" [innerHTML]="'m_static_message-message.mandatory' | staticMsg"> </span>
          </div>
          <div class="p-input-block01__row-body">
            <div class="p-input-block01__row-body-item">
              <div class="p-input-block01__row-body-item-box p-input-block01__row-body-item-box--w325">
                <asw-input
                  id="payment-credit-info-email"
                  label="{{ 'label.eMailAddress' | staticMsg }}"
                  formControlName="email"
                  (change$)="emailChange()"
                  maxlength="50"
                ></asw-input>
                <div></div>
              </div>
            </div>

            <div class="p-input-block01__row-body-item">
              <div class="p-input-block01__row-body-item-box p-input-block01__row-body-item-box--w325">
                <asw-input
                  id="payment-credit-info-email-again"
                  label="{{ 'label.confirmMailAddress' | staticMsg }}"
                  formControlName="emailAgain"
                  (change$)="emailChange()"
                  maxlength="50"
                  disablePaste
                ></asw-input>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="p-input-block01__item">
        <div class="p-input-block01__row p-input-block01__row--has-title">
          <div class="p-input-block01__row-head">
            <span class="p-input-block01__row-title" [innerHTML]="'label.telephoneNumber' | staticMsg"> </span>
            <span class="c-label-required" [innerHTML]="'m_static_message-message.mandatory' | staticMsg"> </span>
          </div>
          <div class="p-input-block01__row-body">
            <!-- 国選択 -->
            <div class="p-input-block01__row-body-item">
              <div class="p-input-block01__row-body-item-box p-input-block01__row-body-item-box--w325">
                <!-- 選択肢によって１つ下の「Phone Number（.c-form-element-input--phone）」内の「c-form-element-input__input-code」のテキストが変化します。 -->
                <asw-select
                  id="payment-credit-country-select"
                  label="{{ 'label.countryCode' | staticMsg }}"
                  formControlName="countryCode"
                  (change$)="countryChange()"
                >
                  <option value="" [innerHTML]="'m_static_message-placeholder.pleaseSelect' | staticMsg"></option>
                  <option
                    *ngFor="let phoneCountryInfo of phoneCountryInfoList"
                    value="{{ phoneCountryInfo.countryCode === undefined ? '-' : phoneCountryInfo.countryCode }}"
                    [innerHTML]="phoneCountryInfo.countryName"
                  ></option>
                </asw-select>
              </div>
            </div>
            <!-- 電話番号 -->
            <div class="p-input-block01__row-body-item">
              <div class="p-input-block01__row-body-item-head">
                <p
                  id="describe01"
                  class="p-input-block01__row-body-item-text"
                  [innerHTML]="'message.phoneNumberAttention' | staticMsg"
                ></p>
              </div>
              <div class="p-input-block01__row-body-item-box p-input-block01__row-body-item-box--w325">
                <asw-input
                  id="payment-credit-telephone"
                  label="{{ 'label.telephoneNumber' | staticMsg }}"
                  formControlName="number"
                  (change$)="telephoneChange()"
                  placeholder="{{ 'placeholder.phoneNumber.international' | staticMsg }}"
                  phoneCode="{{ this.countryPhoneExtension !== '' ? '+' + this.countryPhoneExtension : '' }}"
                  displayType="phone"
                  maxlength="16"
                ></asw-input>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
